import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/roles';

import Roles from './Roles';
import {resetStore} from "../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.roles,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(Roles);
